<template>
  <div class="page">
    <!-- 我的二维码 -->
    <van-nav-bar
      title=""
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />

    <div class="top-tabs">
      <van-tabs
        v-model="active"
        @click="changeTab"
        title-inactive-color="#B5B5B5"
      >
        <van-tab
          v-for="(title, index) in tabsArr"
          :key="index"
          :title="title"
        ></van-tab>
      </van-tabs>
    </div>
    
    <div class="main">
      <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="getmore"
            >
        <div class="info-box" v-for="(i, j) in dataList3" :key="j">
        <div class="time-hx" data-flex="main:justify cross:center">
          <div class="time">预约日期：{{ i.date }}</div>
          <div class="hx" v-show="i.status == 1">待核销</div>
          <div class="hx" v-show="i.status == 2" style="color: #FD4A46;">
            已核销
          </div>
        </div>
        <div class="sqdw" data-flex="cross:center">
          <div class="sq">申请单位：</div>
          <div class="dw">{{ i.applicantName }}</div>
        </div>
        <div class="ldxm" data-flex="cross:center">
          <div class="ld">领队姓名：</div>
          <div class="xm">{{ i.realname }}</div>
        </div>
        <div class="yyrs" data-flex="cross:center">
          <div class="yy">预约人数：</div>
          <div class="rs">{{ i.population }}</div>
        </div>
        <div
          class="ewm"
          data-flex="cross:center main:right"
          v-if="i.status == 1"
        >
          <div class="ewm-btn" data-flex="cross:center main:center" @click="showImg(i)">二维码</div>
        </div>
      </div>
      </van-list>
    </div>

    <div class="bg" v-show="showqr">
        <div class="qrbox">
        <div class="qrtitle">二维码</div>
        <div ref="qrcode" class="qrcode">
            <img :src="codedata | qiniuImageView(1, 160, 160)"  >

        </div>
        <div class="dhx" v-show="this.ishe == 1">待核销</div>
        <div class="dhx" v-show="this.ishe == 2">已核销</div>
        <div class="qrbtn" @click="showqr= false">
            <div class="qrbtn-txt" >关闭</div>
        </div>
        </div>
    </div>

  </div>
</template>

<script>
import mix1 from "@/mixins/page";
import { uiShowLoading, uiHideLoading, uiAlert, uiConfirm } from "@/utils/ui";
import { delayAsync } from "@/utils/common";
import { CellGroup, Tab, Tabs, List, NavBar  } from "vant";


export default {
  created(){
    // this.dataList3 = this.dataList;
    this.getList();
  },
  name: "myQrcode",
  mixins: [mix1],
  components: {
    [NavBar.name]: NavBar,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [List.name]: List,
  },
  data() {
    return {
      isScanning: false, // 扫码
      active: 0,
      tabsArr: ["全部", "待核销", "已核销"],
      dataList: [
        {
          time: "2024-11-11",
          hx: 0, //0待核销1已核销
          sqdw: "XX名称",
          ldxm: "谭洋",
          yyrs: 10,
          ewm: 0 //0待核销1已核销
        },
        {
          time: "2024-11-11",
          hx: 1, //0待核销1已核销
          sqdw: "XX名称",
          ldxm: "邓勇",
          yyrs: 10,
          ewm: 1 //0待核销1已核销
        },
        {
          time: "2024-11-11",
          hx: 1, //0待核销1已核销
          sqdw: "XX名称",
          ldxm: "邓军",
          yyrs: 10,
          ewm: 1 //0待核销1已核销
        }
      ],
      dataList3:[],//渲染数组
      qrtxt: "http://www.baidu.com",
      showqr: false,

      loading: false,
      finished: false,
      pagenum:1,
      pageSize:10,

      codedata:"",
      showqr:false,
      ishe:false,

    };
  },
  methods: {
    onClickLeft(){
      this.$router.go(-1);
    },

    async getList(){
      uiShowLoading();
        let data = {};
        data.page = this.pagenum;
        data.pageSize = this.pageSize;
        data.type = 2;//我的二维码
        data.status = this.active;//0全部1待核销2已核销
        const promise = this.apiGet('yy.postForm',data)
        let apiResult = null
        try {
            apiResult = await promise
        } catch (ex) {
            apiResult = null
        }
        if (this.isEmpty(apiResult)) {
            console.log("空了");
            this.loading = false;
            this.finished = true;
            return
        }
        this.dataList3 = apiResult.list;
        this.loading = false;
        // if(apiResult.list.length < 10){
        //     this.finished = true;
        // }
        console.log("this.dataList3=>",this.dataList3);
        uiHideLoading();
    },

    async getmore(){
      // if(this.dataList3.length < 10){
      //   return
      // }
        this.pagenum++;
        let data2 = {};
        data2.page = this.pagenum;
        data2.pageSize = this.pageSize;
        data2.type = 2;//我的二维码
        data2.status = this.active;//0全部1待核销2已核销
        const promise = this.apiGet('yy.postForm',data2)
        let apiResult = null
        try {
            apiResult = await promise
        } catch (ex) {
            apiResult = null
        }
        if (this.isEmpty(apiResult)) {
                console.log("空的");
                this.loading = false;
                this.finished = true;
        }
        this.dataList3 = this.dataList3.concat(apiResult.list);
        if(apiResult.list.length < 10){
          console.log("返回的数据小于10个");
                this.finished = true;
            }
        console.log("this.dataList3=>",this.dataList3);
        //   // 加载状态结束
        this.loading = false;
        
    },

    changeTab(e) {
      console.log("tab切换");
      this.pagenum = 1;
      this.loading = false;
      this.finished = false;
      this.getList();
    },

    showImg(x){
      console.log("当前二维码内容：",x);
      if(x.verificationCode != "" && x.verificationCode != undefined && x.verificationCode != null ){
            this.codedata = x.verificationCode;
            this.ishe = x.status;
            this.showqr = true;
      }else{
        this.getdetail(x.id)
      }
            
    },

   async getdetail(c){
      let y = c;
			let data = {id:y}
      const promise = this.apiGet('hexiaoListXq',data)
      let apiResult = null
        try {
            apiResult = await promise
        } catch (ex) {
            apiResult = null
        }
        if (this.isEmpty(apiResult)) {
          console.log("进入判空了");
					return;
				}
        console.log("apiResult",apiResult);
        this.codedata = apiResult.obj.verificationCode;
        this.ishe = apiResult.obj.status;
        this.showqr = true;
    },






  },
  computed: {}
};
</script>

<style lang="less" scoped>
.page {
  overflow: hidden;
  .top-tabs {
    margin-bottom: 25px;
  }
  .main {
    .info-box {
      margin: 0 auto;
      width: 710px;
      // height: 377px;
      background: #ffffff;
      border-radius: 15px 15px 15px 15px;
      margin-bottom: 10px;
      padding: 22px 30px 20px 24px;
      // border: 1px solid red;
      .time-hx {
        height: 40px;
        .time {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          height: 40px;
          font-size: 11px;
          color: #030303;
          line-height: 40px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
        .hx {
          width: 84px;
          height: 40px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 11px;
          color: #13a6fa;
          line-height: 40px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }
      .sqdw {
        margin-top: 23px;
        .sq {
          // width: 140px;
          height: 40px;
          font-family: PingFang SC, PingFang SC;
          font-weight: bold;
          font-size: 14px;
          color: #030303;
          line-height: 40px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
        .dw {
          // width: 93px;
          height: 40px;
          font-family: PingFang SC, PingFang SC;
          font-weight: bold;
          font-size: 14px;
          color: #030303;
          line-height: 40px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }
      .ldxm {
        margin-top: 18px;
        .ld {
          // width: 140px;
          height: 40px;
          font-family: PingFang SC, PingFang SC;
          font-weight: bold;
          font-size: 14px;
          color: #030303;
          line-height: 40px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
        .xm {
          // width: 56px;
          height: 40px;
          font-family: PingFang SC, PingFang SC;
          font-weight: bold;
          font-size: 14px;
          color: #030303;
          line-height: 40px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }
      .yyrs {
        margin-top: 18px;
        .yy {
          // width: 140px;
          height: 40px;
          font-family: PingFang SC, PingFang SC;
          font-weight: bold;
          font-size: 14px;
          color: #030303;
          line-height: 40px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
        .rs {
          // width: 43px;
          height: 50px;
          font-family: PingFang SC, PingFang SC;
          font-weight: bold;
          font-size: 18px;
          color: #fd4a46;
          line-height: 50px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }
      .ewm {
        // border: 1px solid red;
        // width: 178px;
        height: 68px;
        .ewm-btn {
          width: 178px;
          height: 68px;
          background: #ffffff;
          border-radius: 34px 34px 34px 34px;
          border: 2px solid #13a6fa;
          color: #13a6fa;
        }
      }
    }
  }
}

.bg {
    margin: 0 auto;
    width: 100vw;
    height: 100vh;
    background-color: rgba(70, 70, 70, 0.3);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    // justify-content: center;
    .qrbox{
      margin: 0 auto;
      display: flex;
      // align-items: center;
      flex-wrap: wrap;
      justify-content: center;
      width: 632px;
      height: 751px;
      background: #FFFFFF;
      border-radius: 15px 15px 15px 15px;
      .qrtitle{
        width: 632px;
        height: 46px;
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 16px;
        color: #000000;
        line-height: 46px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        text-align: center;
        margin-top: 66px;
      }
      .qrcode{
        margin-top: 48px;
      }
      .dhx{
        width: 632px;
        height: 46px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #FF0B0B;
        line-height: 46px;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
      .qrbtn{
        width: 441px;
        height: 88px;
        background: #FD4A46;
        border-radius: 44px 44px 44px 44px;
        display: flex;
        align-items: center;
        justify-content: center;
        .qrbtn-txt{
          // width: 64px;
          height: 46px;
          font-family: PingFang SC, PingFang SC;
          font-weight: bold;
          font-size: 16px;
          color: #FFFFFF;
          line-height: 46px;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }
      }
    }
}





</style>
